// extracted by mini-css-extract-plugin
export default {"root":"shortTermGoal_root__6H6Hl","options":"shortTermGoal_options__Hw68j"};